var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"max-width":"100%","max-height":"8%","dark":"","flat":""}},[_c('v-content',[_c('Header')],1)],1),_c('v-main',[_c('router-view',{attrs:{"path":"$router.key"}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }